import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  CanvasElementType,
  FormContainerVariantType,
  FormListVariantType,
} from '@blaze-runtime/engine-domain';
import { RenderElementDataRowContext } from '@blaze-shared/elements-domain';

import { CanvasElementComponent } from '../../canvas-elements/element-component';

import { CanvasElementBaseComponent } from './base.component';

type FormlikeElements = Extract<CanvasElementType, FormContainerVariantType | FormListVariantType>;

@Component({
  template: '',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class CanvasElementBaseFormlikeComponent<T extends FormlikeElements>
  extends CanvasElementBaseComponent<T>
  implements CanvasElementComponent<T>
{
  abstract validateValue(rowContext?: RenderElementDataRowContext): void;
}
